module.exports = __webpack_public_path__ + "static/media/amphoe.500284ea.svg";